export const DATA_TEST_IDS = {
  confirmEmail: 'auth-page-confirm-email',
  forgotPasswordButton: 'auth-page-forgot-password-button',
  logoRask: 'auth-page-logo-rask',
  resendCodeButton: 'auth-page-resend-code-button',
  signInButton: 'auth-page-sign-in',
  signUpButton: 'auth-page-sign-up-button',
};
